export const PasswordTypes = {
    GET_PASSWORD:'GET_PASSWORD',
    UPDATE_PASSWORD:'UPDATE_PASSWORD'
}